import React from 'react'
import Container from '../../../../components/Container'
import { FormTutorials } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const TutorialCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormTutorials typeForm="create" />
  </Container>
)

export default TutorialCreate
